module.exports = __webpack_public_path__ + "img/131.dcc0b72c.jpg";